import { LogService } from 'library/ts/utilities/logger/LogService';
import * as DOM from 'library/ts/utilities/modules/DOM';
import * as Type from 'library/ts/utilities/modules/Type';
const logger = LogService.create({ prefixes: ['SmartTag:', 'Utilities:', 'API.executeCallback:'] });
export const executeCallback = (method, namespace = undefined, params = undefined, returnValue = false) => {
    if (Type.isUndefined(namespace))
        return;
    if (Type.isString(namespace))
        namespace = DOM.getDeepVal(window, namespace);
    const apiMethod = (Type.isEmpty(namespace) === false ? DOM.getDeepVal(namespace, String(method)) : undefined);
    switch (Type.isFunction(apiMethod)) {
        case true:
            try {
                switch (returnValue) {
                    case false:
                        apiMethod(params);
                        break;
                    case true:
                        return apiMethod(params);
                        break;
                }
            }
            catch (error) {
                logger.warn('method:', method, 'params:', params, 'ERROR:', error);
            }
            break;
        case false:
            switch (returnValue) {
                case true:
                    logger.warn('method:', method, 'was not found on page', 'params:', params);
                    return undefined;
                    break;
            }
            break;
    }
};
